export const INVITATION_FAILURE_MESSAGE =
  'Unable to process the invitation. It may have already been accepted or is no longer available.';
